import { filterHasValue } from '@akin-home/arrays';
import { OptionModel } from '@akin-home/options';

interface Params {
  allergy_preferences: string[];
  allergy_options: OptionModel[];
}

const allergy_label_to_reference_map: { [key: string]: string } = {
  Dairy: 'allergy_dairy',
  Eggs: 'allergy_egg',
  Peanuts: 'allergy_peanut',
  Wheat: 'allergy_gluten',
  Treenuts: 'allergy_tree_nut',
  Shellfish: 'allergy_shellfish',
  Soy: 'allergy_soy',
  Sesame: 'allergy_sesame',
};

export const getAllergyOptionIDsForAllergyPreferences = ({
  allergy_preferences,
  allergy_options,
}: Params): string[] => {
  return filterHasValue(
    allergy_preferences.map((allergy) => {
      return allergy_options.find(
        (a) => a.code === allergy_label_to_reference_map[allergy]
      )?.id;
    })
  );
};
